import './statistics-list.css'
import StatisticsEnergiesparklasse from "./statistic/statistics-energiesparklasse.tsx";
import StatisticsEnergieverbrauch from "./statistic/statistics-energieverbrauch.tsx";
import StatisticsHeizkosten from "./statistic/statistics-heizkosten.tsx";
import StatisticsProduktionSolarstrom from "./statistic/statistics-produktion-solarstrom.tsx";
import StatisticsRenovierungskosten from "./statistic/statistics-renovierungskosten.tsx";
import StatisticsFoerderprogramme from "./statistic/statistics-foerderprogramme.tsx";
import { useStore } from "../state/state.ts";
import { useEffect } from "react";
import { MAIN_PROPERTIES } from "../state/properties.ts";
import StatisticsCo2Verbrauch from "./statistic/statistics-co2.tsx";

export default function StatisticsList() {
  //const statistics_widgets = useStore((state)=>state.statistic_widgets);
//  const api_calculate_energy_costs = useStore((state) => state.api_calculate_energy_costs);
//  let properties = MAIN_PROPERTIES.reduce((acc, p)=>{
//     acc[p.key] = useStore((state) => state[p.key]);
//     return acc;
//  },{});
 
//  useEffect(()=>{
//     api_calculate_energy_costs((p) => useStore((state) => state.api_calculate_energy_costs));
//   },[properties]);
  const keep_menu_open = useStore((state) => state.keep_menu_open);

              // <div className={clsx("statistic",(selected_menu_item || keep_menu_open) && "layout__col-right--faded")}></div>
  return (
    <>
    {/* <p>Ergebnisse – Bisherige Sanierungen</p> */}
    <div className='statistics-list' aria-live="polite" aria-relevant="text">
      {/* <Tacho label="Energieklasse" now={230} future={150} /> */}
      {/* {statistics_widgets.map((widget: StatisticWidget)=>widget.widget())} */}
      {/* <StatisticsEnergiesparklasse /> */}
      <StatisticsEnergieverbrauch/>
      <StatisticsCo2Verbrauch/>
      <StatisticsProduktionSolarstrom />
      <StatisticsHeizkosten />
      <StatisticsRenovierungskosten />
      <StatisticsFoerderprogramme />
     </div>
    </>
  )
}